"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Files;

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = require("../actions/ActionTypes");

var _Constants = require("../Constants");

var _FoldersAndFiles = require("../utils/FoldersAndFiles");

var defaultState = _immutable.default.Map({
  objects: new _immutable.default.List(),
  total: 0,
  query: null,
  status: _Constants.RequestStatus.UNINITIALIZED,
  timestamp: null,
  videoPlayerRequestStatus: _Constants.RequestStatus.UNINITIALIZED,
  fetchingMore: false
});

function findIndex(state, fileId) {
  return state.get('objects').findIndex(function (item) {
    return item.get('id') === fileId;
  });
}

function replaceFile(state, file) {
  var index = findIndex(state, file.get('id'));

  if (index === -1) {
    return state;
  }

  return state.setIn(['objects', index], file);
}

function updateFile(state, fileId, updates) {
  var index = findIndex(state, fileId);

  if (index === -1) {
    return state;
  }

  var file = state.getIn(['objects', index]);
  file = file.merge(updates);
  return state.setIn(['objects', index], file);
}

function removeFile(state, fileId) {
  var index = findIndex(state, fileId);
  var objects = state.get('objects');
  return state.merge({
    objects: objects.delete(index),
    total: state.get('total') - 1
  });
}

function removeAll(state, files) {
  var nextState = state;
  files.forEach(function (file) {
    nextState = removeFile(nextState, file.get('id'));
  });
  return nextState;
}

function addAll(state, files) {
  if (files.count() === 0) {
    return state;
  }

  return state.merge({
    objects: state.get('objects').concat(files),
    total: state.get('total') + files.count()
  });
}

function Files() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      status = action.status,
      query = action.query,
      data = action.data,
      file = action.file,
      files = action.files,
      fileId = action.fileId,
      tempFile = action.tempFile,
      tempUrl = action.tempUrl,
      progress = action.progress,
      dimensions = action.dimensions,
      fetchingMore = action.fetchingMore;
  var timestamp = new Date().getTime();

  switch (type) {
    case _ActionTypes.FETCH_FILES_ATTEMPTED:
    case _ActionTypes.FETCH_FILES_FAILED:
      return state.merge({
        objects: new _immutable.default.List(),
        total: 0,
        query: query,
        status: status
      });

    case _ActionTypes.SEARCH_FILES_ATTEMPTED:
      state = state.merge({
        query: query,
        fetchingMore: fetchingMore
      });

      if (!fetchingMore) {
        state = state.merge({
          status: status,
          objects: _immutable.default.List()
        });
      }

      return state;

    case _ActionTypes.SEARCH_FILES_SUCCESS:
      {
        var objects = data.get('objects');

        if (fetchingMore) {
          objects = (0, _FoldersAndFiles.toOrderedMap)(state.get('objects')).concat((0, _FoldersAndFiles.toOrderedMap)(objects)).toList();
        }

        return state.merge({
          objects: objects,
          total: data.get('total'),
          query: query,
          status: status,
          fetchingMore: false,
          timestamp: timestamp
        });
      }

    case _ActionTypes.FETCH_FILES_SUCCEEDED:
      return state.merge({
        objects: data.get('objects'),
        total: data.get('total_count'),
        query: query,
        status: status,
        timestamp: timestamp
      });

    case _ActionTypes.FETCH_MORE_FILES_SUCCEEDED:
      {
        var _objects = (0, _FoldersAndFiles.toOrderedMap)(state.get('objects')).concat((0, _FoldersAndFiles.toOrderedMap)(data.get('objects'))).toList();

        return state.merge({
          objects: _objects,
          total: data.get('total_count'),
          fetchingMore: false
        });
      }

    case _ActionTypes.FETCH_MORE_FILES_ATTEMPTED:
      return state.set('fetchingMore', true);

    case _ActionTypes.FETCH_MORE_FILES_FAILED:
      return state.set('fetchingMore', false);

    case _ActionTypes.DOWNLOAD_FROM_DRIVE_SUCCEEDED:
    case _ActionTypes.DOWNLOAD_FROM_CANVA_SUCCEEDED:
    case _ActionTypes.DOWNLOAD_FROM_DROPBOX_SUCCEEDED:
    case _ActionTypes.UPLOAD_FILE_SUCCEEDED:
    case _ActionTypes.SAVE_EDIT_SUCCEEDED:
    case _ActionTypes.UPLOAD_EDITED_IMAGE_SUCCEEDED:
      return state.merge({
        objects: state.get('objects').unshift(file),
        total: state.get('total') + 1
      });

    case _ActionTypes.REPLACE_FILE_PROGRESS:
      return updateFile(state, fileId, {
        progress: progress
      });

    case _ActionTypes.REPLACE_FILE_ATTEMPTED:
      return updateFile(state, fileId, Object.assign({
        replaced: true,
        size: tempFile.size,
        tempUrl: tempUrl,
        progress: progress
      }, dimensions));

    case _ActionTypes.MOVE_FILE_SUCCEEDED:
      if (state.hasIn(['query', 'folder_id'])) {
        return removeFile(state, data.get('id'));
      }

      return replaceFile(state, data);

    case _ActionTypes.DELETE_FILE_SUCCEEDED:
      return removeFile(state, fileId);

    case _ActionTypes.REPLACE_FILE_SUCCEEDED:
    case _ActionTypes.CHANGE_FILE_ACCESSIBILITY_REQUEST_SUCCEEDED:
    case _ActionTypes.REPLACE_FILE_FAILED:
    case _ActionTypes.REMOVE_CANVA_ID_SUCCEEDED:
    case _ActionTypes.RECALCULATE_IMAGE_DIMENSIONS_SUCCESS:
      return replaceFile(state, file);

    case _ActionTypes.RENAME_FILE_ATTEMPTED:
    case _ActionTypes.RENAME_FILE_SUCCEEDED:
    case _ActionTypes.RENAME_FILE_FAILED:
      return replaceFile(state, data);

    case _ActionTypes.ARCHIVE_FILE_SUCCEEDED:
    case _ActionTypes.UNARCHIVE_FILE_SUCCEEDED:
      return removeFile(state, data.get('id'));

    case _ActionTypes.BULK_DELETE_ATTEMPTED:
    case _ActionTypes.BULK_MOVE_ATTEMPTED:
      return removeAll(state, files);

    case _ActionTypes.BULK_DELETE_FAILED:
    case _ActionTypes.BULK_MOVE_FAILED:
      return addAll(state, files);

    case _ActionTypes.CREATE_VIDYARD_PLAYERID_ATTEMPTED:
      return state.merge({
        videoPlayerRequestStatus: _Constants.RequestStatus.PENDING
      });

    case _ActionTypes.CREATE_VIDYARD_PLAYERID_SUCCEEDED:
    case _ActionTypes.SOFT_DELETE_VIDYARD_PLAYERID_SUCCEEDED:
      return replaceFile(state, file).merge({
        videoPlayerRequestStatus: _Constants.RequestStatus.SUCCEEDED
      });

    case _ActionTypes.CREATE_VIDYARD_PLAYERID_FAILED:
    case _ActionTypes.SOFT_DELETE_VIDYARD_PLAYERID_FAILED:
      return state.merge({
        videoPlayerRequestStatus: _Constants.RequestStatus.FAILED
      });

    case _ActionTypes.SELECT_FILE:
      return state.merge({
        videoPlayerRequestStatus: _Constants.RequestStatus.UNINITIALIZED
      });

    case _ActionTypes.VIDEO_THUMBNAIL_UPDATE_SUCCEEDED:
    case _ActionTypes.GENERATE_AND_UPDATE_VIDEO_THUMBNAIL_SUCCEEDED:
      return replaceFile(state, file);

    default:
      return state;
  }
}

module.exports = exports.default;